// [US 6.15] Prédicat Premium unique côté client — miroir exact des deux prédicats serveur :
//   - server/middleware/userAuth.js  : `if (user?.founder_since) return next();` puis premium_until
//   - server/sentinel.js             : `!!user.founderSince || (premiumUntil > now)`
// Il DOIT rester aligné : un fondateur (Premium gracieux perpétuel, hors flux billing) n'a pas de
// `premiumUntil`. Toute duplication manuelle de cette règle a déjà provoqué l'affichage d'un encart
// « Passer à Premium » à des fondateurs, et le blocage de l'activation du push.

/** Forme minimale attendue : `AuthUser`, mais aussi tout objet portant ces deux champs. */
export interface PremiumBearer {
    premiumUntil?: string | null;
    founderSince?: string | null;
}

export const isPremiumUser = (user: PremiumBearer | null | undefined, now: Date = new Date()): boolean => {
    if (!user) return false;
    if (user.founderSince) return true;
    return !!user.premiumUntil && new Date(user.premiumUntil) > now;
};
